import actions from "./actions";
import { message } from "antd";
// import { object } from 'prop-types';
const { DataService } = require("../../config/dataService/dataService");
const { API } = require("../../config/api/index");

const { getMenuItemsData } = actions;

export const menuItemsListData = (tableId) => {
  return async (dispatch) => {
    const getData = await DataService.get(`${API.tableMenuData}/${tableId}`);

    // on an http error the interceptor returns the error body itself
    // (no .data), so check the shape before reading it
    if (getData?.data && !getData.data.error && getData.data.data) {
      let allProducts = getData?.data?.data?.productList || [];
      const tableType = getData?.data?.data?.tableDetails?.hotel_room
        ? "room_order"
        : "qr_order";
      const registerId = getData?.data?.data?.tableDetails?.register_id;
      const enabledProducts = allProducts.filter((product) => {
        if (!product || !product._id) return false;

        if (product.priceBook?.length > 0) {
          const pricebookDetails = product.priceBook.find(
            (val) =>
              (val.orderType === tableType || val.orderType === "all_orders") &&
              val.registerAssignedTo === registerId &&
              !val.disable
          );
          return !!pricebookDetails;
        }
        return true;
      });
      // // Attach filtered productList back to the data object before dispatch
      const filteredPayload = {
        ...getData.data.data,
        productList: enabledProducts,
      };
      return dispatch(getMenuItemsData(filteredPayload));
    } else {
      // http errors were already shown by the interceptor
      if (getData?.data) {
        message.error(getData.data.message || "Table not found");
      }
      return false;
    }
  };
};
export const createOrder = (orderData) => {
  // console.log("🚀 ~ file: actionCreater.js:21 ~ createOrder ~ orderData:", orderData)
  return async (dispatch) => {
    const getData = await DataService.post(`${API.createOrder}`, orderData);
    if (!getData.data.error) {
      return getData.data;
    } else {
      message.error(getData.data.message);
      return false;
    }
  };
};
export const razorpayCreateOrder = (orderData) => {
  return async (dispatch) => {
    const getData = await DataService.post(
      `${API.razorpayCreateOrder}`,
      orderData
    );
    return getData;
  };
};
